module.exports = __webpack_public_path__ + "media/images/landing/dno/product-2-e8f21a540e240c3fae18970ad5868cad.png";